import React from "react";
import { Container, Nav, Navbar, NavDropdown, Button } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";

const Header = () => {
  let activeStyle = {
    color: "#333",
  };
  let navigate = useNavigate()
  return (
    <div className="header" fixed="top">
      <Navbar expand="lg" fixed="top">
        <Container>
          {/* <div className="d-flex">
        <a  href="https://lib.hku.hk/hkul-training-calendar/"  className="text-black fs-6 me-5 logo-home d-flex"> <img src="https://www.bing.com/th?id=OIP.LRKF4hCk_2_94hfpFJJ2BgHaGb&w=268&h=232&c=8&rs=1&qlt=90&o=6&pid=3.1&rm=2" alt="HKUL" width={ 38 } height={24} className="ms-3 logo-phone" ></img> <span className="homepageword ms-1">Home Page</span></a>
        <a  href="https://lib.hku.hk/" target='_blank' className="ms-5 for-phone displayNone" ><img src="https://www.lib.hku.hk/sites/all/themes/bootstrap/hkul_subtheme/images/hkul-logo@2x.png" alt="Calendar" width={ 170 } height={40} className="ms-5 logo-phone  for-phone"></img></a>
        </div> */}

          <Navbar.Brand className="fs-3 calendarTitle"><div className="calendarTitle" ><a  className="ms-4 text-white find rounded p-2 px-4"  href="https://lib.hku.hk/hkul-training-calendar/" >HKU - Library Training Calendar </a ></div></Navbar.Brand>

         
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav className="ml-auto">
            <a  href="https://lib.hku.hk/" target='_blank' className="ms-5 logo-phone"><img src="https://www.lib.hku.hk/sites/all/themes/bootstrap/hkul_subtheme/images/hkul-logo@2x.png" alt="Calendar" width={ 170 } height={40} className="ms-5"></img></a>
              {/* <NavLink
                to="/welcomeWeek"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
                className="nav-link"
              >
                Calendar
              </NavLink> */}

              {/* <NavLink
                to="/submitevent"
                // style={({ isActive }) => (isActive ? activeStyle : undefined)}
                className="nav-link"
              >
                Submit Course
              </NavLink> */}

              {/* <a  href="https://lib.hku.hk/general/instruction/index.html" target='_blank'><span className="me-5 text-secondary bg-light rounded">  HKU Library Training  </span></a> */}
{/*               
              <Button className="mx-3 px-4" style={{backgroundColor: 'rgb(50, 60, 38)'}} onClick={()=>{navigate('/download')}}>Download</Button> */}

            {/* <a  href="https://lib.hku.hk/general/instruction/index.html" target='_blank' style={{ width: '59%', overflow: 'hidden' }} ><img src="https://libapps-au.s3-ap-southeast-2.amazonaws.com/accounts/128565/images/Library_Training__Web_Banner__2023_.png" alt="HKUL" width={ 280 } height={50} className="ms-5"></img></a>                */}
              {/* Login button */}
              {/* <Button className="mx-3 px-4" style={{backgroundColor: 'rgb(58, 62, 58)'}} onClick={()=>{navigate('/login')}}>Login</Button> */}

            </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
